import type Mithril from 'mithril';
import Component from 'flarum/common/Component';
import Discussion from 'flarum/common/models/Discussion';
import icon from 'flarum/common/helpers/icon';
import app from 'flarum/forum/app';

export interface DiscussionShareAttrs {
  discussion: Discussion;
}

export default class DiscussionShare extends Component<DiscussionShareAttrs> {
  view(vnode: Mithril.Vnode<DiscussionShareAttrs, this>) {
    const { discussion } = this.attrs;

    return (
      <span
        className="DiscussionListItem-action"
        onclick={() => {
          if (!app.modalComponents?.ShareModal) {
            return;
          }
          app.modal.show(app.modalComponents.ShareModal, {
            discussion,
          });
        }}
      >
        {icon('fas fa-share-alt')}
        <span>分享</span>
      </span>
    );
  }
}
